import React from 'react'
const CallAction = () => {
    return (
        <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="inner text-center">
                            <span>VOCÊ ESTÁ PRONTO PARA FATURAR?</span>
                            <h2>Vamos ao trabalho! 🚀 </h2>
                            <a className="rn-button-style--2" href="/contact"><span>Entrar em Contato</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CallAction;